
import "./OrderSummary.css";
import { useState } from "react";

import Modal from 'components/Modals'
import { invoiceTypes, modalMsg, payMethodDetails } from "helpers/const";
import { toUpper } from 'lodash'
import moment from 'moment'
const carrierReg = /^\/[0-9A-Z.+-]{7}$/

const OrderSummary = ({
  invoiceInfo, setInvoiceInfo, orderInfo, orderCancel, checkOut, payMethod, setPayMethod
}) => {

  const [modalStatus, setModalStatus] = useState({ open: false, type: null });
  const [isSubmit, setIsSubmit] = useState(false)

  const changeInvoice = (carrierType) => {
    setInvoiceInfo({...invoiceInfo, carrierType})
  }

  const checkCarrier = () => {
    let pass = true;
    if (invoiceInfo.carrierType === invoiceTypes.carrier) {
      if (!carrierReg.test(invoiceInfo.carrierCode)) {
         pass = false;
      }
    }
    return pass;
  }

  const clickBtn = (type) => {
    if (isSubmit) return;
    if (type === modalMsg.payment.value) {
      if (!checkCarrier()) {
        document.getElementById('input-carrier-code')?.scrollIntoView({behavior: 'smooth'})
        return;
      }
      if (payMethod.type === null) {
        document.getElementById('select-pay-type').scrollIntoView({behavior: 'smooth'})
        document.getElementById("select-pay-type").style.border = '2px solid rgb(255, 0, 0)';
        return;
      } else {
        document.getElementById("select-pay-type").style.border = "none";
      }
    }

    setModalStatus({open: true, type});
  }

  const clickCancel = () => {
    setModalStatus({open: false, type: null})
  }

  const clickSubmit = (type) => {
    setIsSubmit(true)
    if (type === modalMsg.cancel.value) {
      orderCancel()
    } else {
      checkOut()
    }
  }

  const getDateFormat = () => {
    return orderInfo?.createdAt ? moment(orderInfo?.createdAt).format('YYYY-MM-DD HH:mm') : '';
  }

  return (
    <>
      <div className="is-order-summary">
        <div className="sub-container">
          <div className="contains-order">
            <div className="total-cost">
              <h3>{orderInfo?.productInfo?.name || '-'} </h3>
              <h3>NTD <span className="actual-product-price">{orderInfo?.productInfo?.price || 0}</span></h3>
            </div>
            <div className="total-cost">
              <h4>
                {`訂單時間: `}
                <span className="actual-product-price">{`${orderInfo?.productInfo?.machineName || ''} ${getDateFormat()}`}</span>
              </h4>
            </div>
            <div className="promo-br"></div>
            <div id="input-carrier-code" className="promo-code">
              <h4>電子發票 / E-Invoice</h4>
              <button
                className={
                  `flat-button ${invoiceInfo.carrierType === invoiceTypes.carrier ? 'apply-promo-clicked' : 'apply-promo'}`
                }
                onClick={() => changeInvoice(invoiceTypes.carrier)}
              > 手機條碼載具 / Mobile carrier </button>
              <button
                className={
                  `flat-button ${invoiceInfo.carrierType === invoiceTypes.donate ? 'apply-promo-clicked' : 'apply-promo'}`
                }
                onClick={() => changeInvoice(invoiceTypes.donate)}
              > 捐贈 / Donate </button>

              <div  className="enter-promo">
                {invoiceInfo.carrierType === 'carrier' &&
                  <>
                    <h5>載具號碼 / Mobile carrier</h5>
                    <input
                      className={ `select-dropdown ${checkCarrier() ? '' : 'inputErr'}`}
                      type="text"
                      placeholder="/xxxxxxx"
                      value={invoiceInfo?.carrierCode}
                      onChange={(e) =>
                        setInvoiceInfo({...invoiceInfo, carrierCode: toUpper(e.target?.value?.replaceAll(/\s/g,''))})
                      }
                  />
                  {!checkCarrier() &&
                    <h5 style={{ color: "#ff2100", margin: '0',  fontWeight: 'bold', }}>
                      格式錯誤 / Invalid format
                    </h5>
                  }
                  </>
                }
              </div>
            </div>
            <div className="promo-br"></div>

            <div id='select-pay-type' className="promo-code">
              <h4>
                付款方式 / Payment methods
              </h4>
              <div  className="cc-selector-2">
                  {
                  Object.values(payMethodDetails)?.map((item) => {
                    return <>
                      <button
                          className={
                            `flat-button ${payMethod.type === item.value ? 'apply-promo-clicked' : 'apply-promo'}`
                          }
                          onClick={() => setPayMethod(pre=>({...pre, type: item.value}))}
                        > {item.label}
                      </button>
                    </>
                  })
                }
	      </div>
            </div>
            <div className="promo-br"></div>
            <div className="final-cost">
              <h3>結帳金額 / Total</h3>
              <h4>NTD <span className="actual-product-price">{orderInfo?.productInfo?.price}</span></h4>
            </div>
            <div className="final-checkout">
              <button
                className="flat-button checkout-cancel"
                onClick={() => clickBtn(modalMsg.cancel.value)}
                disabled={isSubmit}
              >取消 / Cancel</button>
              <button
                className="flat-button checkout"
                onClick={() => clickBtn(modalMsg.payment.value)}
                disabled={isSubmit}
              >確認付款 / Submit</button>
            </div>
          </div>
        </div>
      </div>
      {modalStatus?.open &&
        <Modal {...{modalStatus, clickCancel, clickSubmit}} />
      }
    </>
  );
};
export default OrderSummary;
